import { Link } from "react-router-dom"

function NavBar() {

    return (
        <nav>
            <div className="navflex-container">
                <div className="navflex-item item-1">
                    <h1>
                        <Link to="/">Kyle Veloso</Link>
                    </h1>
                </div>
                <menu className="navflex-item item-2">
                    <div className="link-button"><Link to="/about">About me</Link></div>
                    <div className="link-button"><Link to="/skills">My Skills</Link></div>
                    <div className="link-button"><Link to="/projects">My Projects</Link></div>
                    <div className="link-button"><Link to="/leisure">Leisure</Link></div>
                </menu>
            </div>
        </nav>
    )
}


export default NavBar